import moment from "moment";

// Certificato medico-sportivo: conta l'ultimo per scadenza, così un certificato
// rinnovato non resta "scaduto" per colpa di quello vecchio.
export const CERTIFICATE_EXPIRING_DAYS = 30;

export const CERTIFICATE_STATUS = {
	ok: {label: "In regola", tone: "good"},
	expiring: {label: "In scadenza", tone: "warning"},
	expired: {label: "Scaduto", tone: "critical"},
	missing: {label: "Nessun certificato", tone: "neutral"},
};

export const certificateStatus = (certificates, now = moment()) => {
	const latest = (certificates || [])
		.filter((c) => c?.expiryDate)
		.sort((a, b) => moment(b.expiryDate).diff(moment(a.expiryDate)))[0];
	if (!latest) return {status: "missing", certificate: null, daysLeft: null};
	const daysLeft = moment(latest.expiryDate)
		.startOf("day")
		.diff(moment(now).startOf("day"), "days");
	return {
		status:
			daysLeft < 0
				? "expired"
				: daysLeft <= CERTIFICATE_EXPIRING_DAYS
					? "expiring"
					: "ok",
		certificate: latest,
		daysLeft,
	};
};

// Testo breve per badge e avvisi: "Scaduto il 12/10", "Scade il 3/11"
export const certificateNote = ({status, certificate}) => {
	if (!certificate) return CERTIFICATE_STATUS.missing.label;
	const date = moment(certificate.expiryDate).format("DD/MM/YYYY");
	return status === "expired" ? "Scaduto il " + date : "Scade il " + date;
};
